import React, { useCallback } from 'react';
import classnames from 'classnames';
import { withMatureContext } from '@wix/da-react-context/pkg/MatureContext';
import DOMPurify from 'isomorphic-dompurify';
import { useDispatch } from 'react-redux';
import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
import s from './LegacyTextRenderer.scss';
function createMarkup(text) {
    return {
        __html: DOMPurify.sanitize(text, {
            FORCE_BODY: true,
            ADD_TAGS: [
                'iframe'
            ]
        })
    };
}
export const LegacyTextRenderer = /*#__PURE__*/ React.forwardRef(({ html, className, theme, showMatureContent, disableStyles, withSafetyCheckModal }, ref)=>{
    const dispatch = useDispatch();
    const safeUrlHandler = useCallback((e)=>{
        const clickedEl = e.target;
        if (clickedEl.tagName === 'A') {
            const anchor = clickedEl;
            var _anchor_getAttribute;
            let href = (_anchor_getAttribute = anchor.getAttribute('href')) !== null && _anchor_getAttribute !== void 0 ? _anchor_getAttribute : '';
            href = href.replace(/^https?:\/\/www\.deviantart\..*\/users\/outgoing\?/i, '');
            if (!/^https?:\/\/www\.deviantart\..*\//.test(href)) {
                e.preventDefault();
                e.stopPropagation();
                dispatch(pushModal(ModalType.SAFE_URL, {
                    params: {
                        href
                    }
                }));
            }
        }
    }, [
        dispatch
    ]);
    if (!html) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames('legacy-journal', !disableStyles && theme && s['legacy'], !disableStyles && theme && s[theme], !showMatureContent && 'maturefilter', className),
        dangerouslySetInnerHTML: createMarkup(html),
        ref: ref,
        onClickCapture: withSafetyCheckModal ? safeUrlHandler : undefined
    }));
});
LegacyTextRenderer.displayName = 'LegacyTextRenderer';
export default withMatureContext(LegacyTextRenderer);
